// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"Yu-z","giftOrPromoSelector":"Zu-z","disabled":"_u-z","subTitle":"av-z","selectShipAddressMessage":"bv-z","changePayment":"cv-z"};